<template>
  <div>
    <b-card-body class="px-0 pt-1 pb-0">
      <b-row no-gutters class="g-1">
        <b-col v-for="(job, index) in professionsToShow" :key="index" cols="12" lg="6">
          <professions-item
            :top="index < 6"
            :index="index + 1"
            :title="job.tit"
            :name="job.name"
            :rank="job.rank"
            :show-rank-bars="showRankBars"
            :inf="job.inf"
            :pdf="job.pdf"
            :plt="job.plt"
            :quantity="job.amt"
            :id="job.id"
            :is-auth="isAuth"
            :language-sid="languageSid"
            :sid="sid"
          />
        </b-col>
      </b-row>
    </b-card-body>
    <b-card-body v-if="isShowMoreVisible" class="p-0">
      <a href="#" @click.prevent="jobShow = !jobShow" class="togglelabel collapsed fs-6 fw-bold">
        <span class="label">{{ jobShow ? translations[14014] : translations[13645] }}</span>
      </a>
    </b-card-body>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import ProfessionsItem from '@/components/Home/ProfessionsItem.vue';
import { AppModule } from '@/store/modules/app';

const DEFAULT_COUNT_TO_SHOW = 50;

@Component({
  components: {
    ProfessionsItem,
  },
})
export default class ProfessionsList extends Vue {
  @Prop({ default: () => [] }) private items!: any;

  @Prop({ default: false }) isAuth!: boolean;

  @Prop({ default: '' }) languageSid!: string;

  @Prop({ default: false }) showRankBars!: boolean;

  get translations() {
    return AppModule.translation;
  }

  get isShowMoreVisible() {
    return this.items.length > DEFAULT_COUNT_TO_SHOW;
  }

  jobShow = false;

  get professionsToShow() {
    return this.jobShow ? this.items : this.items.slice(0, DEFAULT_COUNT_TO_SHOW);
  }

  get sid() {
    return AppModule.sid;
  }
}
</script>
<style scoped lang="scss"></style>
